import { httpClient } from '@/lib/httpClient';

export enum RecommendationSettingType {
  PRODUCT = 'PRODUCT',
  CATEGORY = 'CATEGORY',
  SHOP_THE_LOOK = 'SHOP_THE_LOOK',
  CUSTOM_SHELF = 'CUSTOM_SHELF',
}

export enum DiscountFilterType {
  ALL = 'ALL',
  WITH_DISCOUNT = 'WITH_DISCOUNT',
  WITHOUT_DISCOUNT = 'WITHOUT_DISCOUNT',
}

export interface Filters {
  brokenStock: {
    active: boolean;
  };
  discount: {
    type: DiscountFilterType;
    range: {
      from: number;
      to: number;
    };
    active: boolean;
  };
  price: {
    range: {
      from: number;
      to: number;
    };
    active: boolean;
  };
  lowStock: {
    stockLimit: number;
    active: boolean;
  };
}

export interface RecommendationSetting {
  id: number;
  customerId: number;
  type: RecommendationSettingType;
  filters?: Filters | null;
}

export interface UpdateRecommendationSettingDto {
  filters?: Filters | null;
}

class RecommendationSettingsService {
  constructor() {}

  async findByType(type: RecommendationSettingType) {
    const { data } = await httpClient.get<RecommendationSetting>(
      `/v1/recommendation-settings/type/${type}`,
    );

    return data;
  }

  async updateByType(
    type: RecommendationSettingType,
    dto: UpdateRecommendationSettingDto,
  ) {
    const { data } = await httpClient.put<RecommendationSetting>(
      `/v1/recommendation-settings/type/${type}`,
      dto,
    );

    return data;
  }
}

export default new RecommendationSettingsService();
